import Card from 'honeydew/Card';
import { Divider } from 'honeydew/Divider';
import { CustomizeIcon, DeliveryTruckIcon, NoCheckoutIcon, ShoppingCartIcon } from 'honeydew/icons/MyPlan';
import useGlobalStore from 'hooks/useGlobalStore';

function PlanInformation() {
    const { isMisfitsTheme } = useGlobalStore();

    const planInfo = [
        {
            id: 1,
            title: 'A cart built just for you',
            text: `We'll start you off with personalized, high-quality produce, sustainably sourced groceries, and more.`,
            icon: <ShoppingCartIcon />,
        },
        {
            id: 2,
            title: 'Shop and customize',
            text: 'Log in anytime during your shopping window to add or remove from your order.',
            icon: <CustomizeIcon />,
        },
        {
            id: 3,
            title: 'No checkout needed',
            text: 'Your order will be confirmed and charged when your shopping window closes, as long as it meets your order minimum.',
            icon: <NoCheckoutIcon />,
        },
        {
            id: 4,
            title: 'Easy home delivery',
            text: 'Your box will get dropped off right at your door, no lugging required.',
            icon: <DeliveryTruckIcon isMisfits={isMisfitsTheme} />,
        },
    ];

    return (
        <Card>
            <div className="grow gap-70 md:flex">
                <h2 className="text-body-lg mb-20 font-grotesk-bold md:min-w-[180px]">Grocery Subscription</h2>

                <div>
                    {planInfo.map((item, i) => (
                        <div key={item.id}>
                            <div className="grid grid-cols-[60px_1fr] gap-20 md:gap-30">
                                {item.icon}
                                <div>
                                    <p className="font-grotesk-bold">{item.title}</p>
                                    <p className="text-body-sm">{item.text}</p>
                                </div>
                            </div>
                            {i !== planInfo.length - 1 && <Divider />}
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    );
}

export default PlanInformation;
